import type { SyntheticEvent } from "react";
import { CountryIso2 } from "ui/widgets/CountrySelector";
import type { CsvValue, SetupValueProps } from "../types";
import { withUnique } from "./common";
import { FormField } from "../../types";

const CsvCountry = ({ values, onChange }: SetupValueProps<CsvValue>) => {
    const onAutocompleteChange = (_: SyntheticEvent, countriesIso2: Array<string>) =>
        onChange!(countriesIso2);

    return (
        <CountryIso2
            multiple
            fullWidth
            disableClearable
            layout={null}
            sx={{
                gridColumn: 'span 2'
            }}
            value={values[FormField.SetupValue].value}
            onChange={onAutocompleteChange}
            TextFieldProps={{
                name: FormField.SetupInputValue,
                label: 'Country'
            }}
        />
    );
};

export default withUnique(CsvCountry);
